import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseModule from './courseModule.module.scss';

export const CourseModuleOne = ({ badgeText, resultText }) => {
  return (
    <section className={`${courseModule.courseModule} ${courseModule.courseModuleOne}`}>
      <div className="container">
        <h2 className={`${courseModule.courseModule__title} ${main.mainTitle}`}>
          Каждый {badgeText} развивает свой набор необходимых ребенку навыков:
        </h2>
        <p className={courseModule.courseModule__important}>{badgeText} 1</p>
        <h3 className={courseModule.courseModule__subtitle}>
          Развитие внимания, памяти, воображения и&nbsp;интеллектуальной выносливости
        </h3>
        <p className={courseModule.courseModule__description}>
          Ребенок освоит техники и&nbsp;методы, которые позволят быстро запоминать в&nbsp;долгосрочную память и
          качественно воспроизводить школьный материал, а&nbsp;так&nbsp;же любую информацию по&nbsp;учебе или работе.
        </p>
        <div className={`row ${courseModule.courseModule__row}`}>
          <div className="col-12 col-lg-9">
            <p className={courseModule.courseModule__listTitle}>Формируемые навыки:</p>
            <ul className={courseModule.courseModule__list}>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Фокусировать внимание от&nbsp;30&nbsp;минут до&nbsp;6&nbsp;часов
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Выделять главное в&nbsp;тексте</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Определять нужный способ запоминания</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать иностранные слова</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Запоминать даты истории и&nbsp;другую числовую информацию
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать географические карты</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать майнд-карты</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать стихи</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать тексты дословно</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать формулы</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать термины и определения</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать правила</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Запоминать ударения, архаизмы и другую нелогичную информацию
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Дольше сохранять сосредоточенность без усталости</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Увеличить интеллектуальный тонус</p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>
                  Развить воображение и&nbsp;визуальное (предметно-образное) мышление
                </p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>
                  Управление интеллектуальным состоянием, навык всегда «быть в&nbsp;ресурсе»
                </p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>Синхронизировать работу полушарий мозга</p>
              </li>
            </ul>
          </div>
          <div className={`col-12 col-lg-3 ${courseModule.courseModule__sideData}`}>
            <div className={main.sideData}>
              <p className={main.sideData__bigText}>
                <span className={main.sideData__bigTextAccent}>200</span> дат
              </p>
              <p className={main.sideData__smallText}>можно запомнить за&nbsp;2-&nbsp;3&nbsp;часа</p>
            </div>
            <div className={main.sideData}>
              <p className={main.sideData__bigText}>
                <span className={main.sideData__bigTextAccent}>500+</span>
              </p>
              <p className={main.sideData__smallText}>слов можно запомнить за&nbsp;один день</p>
            </div>
          </div>
        </div>

        <div className={courseModule.courseModule__result}>
          <h3 className={courseModule.courseModule__resultTitle}>{resultText}</h3>
          <div className="row">
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Быстро и&nbsp;легко запоминать в&nbsp;долгосрочную память и&nbsp;воспроизводить информацию любого типа
                и&nbsp;сложности
              </p>
            </div>
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Концентрация внимания от&nbsp;6&nbsp;минут до&nbsp;5&nbsp;часов позволит фокусироваться на&nbsp;целях
                и&nbsp;всегда быть бодрым и&nbsp;целеустремленным
              </p>
            </div>
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Ребенок на&nbsp;своем опыте осознает, что его возможности в&nbsp;разы больше, чем он мог мечтать
                и&nbsp;приобретет опыт успешного управления своим развитием, что сделает его самостоятельным
                и&nbsp;более мотивированным
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
